import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './style.css'

const ScreeningHistoryButtonHome = () => {
    const navigate = useNavigate();
    const onClickLink = () => {
        navigate('/historial-screening');
    }
    const { screeningHistory } = useSelector(state => state.exams);
    return (
        <>
            {screeningHistory && screeningHistory.hasBackupData ? (
                <div className='screening-btn-content'>
                    <Button
                        className="sticker-btn pb-2 mb-5"
                        aria-label="Ver histórico anual"
                        title="Ver histórico anual"
                        onClick={onClickLink}
                    >
                        <span className="sticker-btn__text">Historial médico</span>
                    </Button>
                </div>
            ) : null}
        </>
    );
}

export default ScreeningHistoryButtonHome;